import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  ENUM_PERMISSIONS_LIST
} from "./actionTypes"
import {
  enumPermissionsListSuccess,
  enumPermissionsListError
} from "./actions"

import {
  apiGetEnumPermissionsList,
} from "../../../api/calls/enums/permissions"

function* enumPermissionsList({payload: data}) {
  try {
    const response = yield call(apiGetEnumPermissionsList, data)
    yield put(enumPermissionsListSuccess(response))
  } catch (error) {
    yield put(enumPermissionsListError(error))
  }
}

export function* watchEnumPermissionsList() {
  yield takeEvery(ENUM_PERMISSIONS_LIST, enumPermissionsList);
}

function* enumPermissionsSaga() {
  yield all([
    fork(watchEnumPermissionsList),
  ]);
}

export default enumPermissionsSaga
